module.exports = {
    api: process.env.REACT_APP_API_URL
}
